// extracted by mini-css-extract-plugin
export default {"bottom_nav_wrapper":"BottomNav_bottom_nav_wrapper__mH8bT"};